import React, {useContext} from 'react'
import {Box} from "@mui/system";
import {OrgCustomizationContext} from "../themes/OrgCustomizationProvider";
import {ImageKey} from "../themes/orgs/OrgCustomizedConfiguration";

type OrgMappedImageProps = { imageKey: ImageKey }

const OrgMappedImage: React.FC<OrgMappedImageProps> = ({imageKey}) => {
    const {imageMap} = useContext(OrgCustomizationContext)

    const configuration = imageMap[imageKey]

    if (!configuration) return null

    return (
        <Box
            component='img'
            src={configuration.src}
            alt={configuration.alt || ''}
            sx={configuration.sx}
            style={configuration.style}
        />
    )
}

export default OrgMappedImage
